Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Header390743503",
  {"wrapper":"Header390743503--wrapper","suffix":"Header390743503--suffix","titleWrapper":"Header390743503--titleWrapper","root":"Header390743503--root"},
  ".Header390743503--wrapper{display:flex;align-items:center;justify-content:space-between;padding:27px 30px 26px}.Header390743503--suffix{height:0;display:flex;align-items:center}.Header390743503--titleWrapper{min-width:0}",
  1,
  "Header390743503"
);
__webpack_require__.stylable.$.register(exports.default)
